export class ContactData {
  subject: string;
  name: string;
  email: string;
  phone: string;
  msg: string;
  captcha: string;
  product?: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+contacts/contact.schema.ts